import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { getFieldValue, RichText } from "@sitecore-jss/sitecore-jss-react";
import CloseIcon from "components/icons/Close";
import {
  useUiValue,
  setNotificationStatus,
  setNotificationHeight,
} from "stores/uiContext";
import styled from "styled-components";
import cx from "classnames";
import { useMeasure } from "react-use";
import { useSpring, animated } from "react-spring";

const BannerContainer = styled.div`
  min-height: 3.73rem;
  padding-left: 1.875rem;
  padding-right: 1.875rem;
`;
const RichTextContainer = styled.div`
  overflow-wrap: break-word;
`;

const HIDE_NOTIFICATION = "hideNotification=";

const NotificationBanner = ({ fields = {} }) => {
  let hideNotificationSession = false;

  if (typeof window !== "undefined" && document) {
    hideNotificationSession =
      typeof document.cookie === "string" &&
      document.cookie.includes(HIDE_NOTIFICATION + "true");
  }

  const [ref, { height }] = useMeasure();
  const activeField = getFieldValue(fields, "active");
  const nBannerText = getFieldValue(fields, "bannerText");
  const mBText = getFieldValue(fields, "marketBannerText") || "";
  const mBActive = getFieldValue(fields, "marketBannerActive") || false;
  const mBAlignment = getFieldValue(fields, "marketBannerAlignment") || "left";

  const textValue = mBActive ? "<p>" + mBText + "</p>" : nBannerText;
  const [
    { notificationActive, hasCommingSoonCommunity, nationalNotificationHeight },
    dispatch,
  ] = useUiValue();

  useEffect(() => {
    dispatch(
      setNotificationStatus(
        (activeField === "1" || mBActive) && !hideNotificationSession
      )
    );
  }, []);

  useEffect(() => {
    if (hasCommingSoonCommunity && !mBActive)
      dispatch(setNotificationStatus(false));
  }, [hasCommingSoonCommunity]);

  const closeNotification = () => {
    dispatch(setNotificationStatus(false));
    document.cookie = HIDE_NOTIFICATION + "true";
  };

  const [fixedBarVisible, setFixedBarVisible] = useState(false);
  /*const breakpoint = useBreakpoint(
    typeof window !== "undefined" && window.innerWidth
  );*/
  //const isMobile = ["sm", "xs", "md"].includes(breakpoint);

  const handleOnScroll = () => {
    //if (!isMobile) {
    const currentScrollY = window.scrollY;
    let offset = 10;
    if (currentScrollY > offset) {
      setFixedBarVisible(true);
    } else if (fixedBarVisible) {
      setFixedBarVisible(false);
    }
    //}
  };

  useEffect(() => {
    window.addEventListener("scroll", handleOnScroll);
    return () => window.removeEventListener("scroll", handleOnScroll);
  }, [handleOnScroll]);

  const fixedBarStyle = useSpring({
    height: height ? height + 32 : "auto",
    config: { duration: 10 },
    top: fixedBarVisible ? nationalNotificationHeight : 0,
  });

  useEffect(() => {
    if (notificationActive && textValue) {
      dispatch(setNotificationHeight(height + 32));
    } else {
      dispatch(setNotificationHeight(0));
    }
  }, [height, notificationActive]);

  if (!notificationActive || !textValue) {
    return null;
  }

  return ReactDOM.createPortal(
    <animated.div
      className={cx("z-40 ", {
        "relative ": !fixedBarVisible,
        "fixed top-0": fixedBarVisible,
      })}
      style={fixedBarStyle}
    >
      <BannerContainer
        ref={ref}
        className={cx(
          "w-screen flex items-start justify-between bg-action-blue py-4 z-50",
          {
            absolute: !!height,
          }
        )}
        role={"region"}
        aria-label={"notification"}
      >
        <RichTextContainer
          className={cx("w-full text-white font-graphie", {
            "text-center": mBActive && mBAlignment === "center",
            "text-right": mBActive && mBAlignment === "right",
            "text-left": mBActive && mBAlignment === "left",
          })}
        >
          <RichText
            tag="span"
            className="richtext"
            field={{ value: textValue }}
          ></RichText>
        </RichTextContainer>
        <button
          tabIndex={-1}
          className="mt-1"
          onClick={closeNotification}
          aria-label="Close notification banner"
          id="notification-banner-index"
        >
          <CloseIcon className="text-white w-6 h-6" />
        </button>
      </BannerContainer>
    </animated.div>,
    typeof window !== "undefined" &&
      document.getElementById("notification-banner")
  );
};

export default NotificationBanner;
